<div class="bmw-bulletin-container">
  <div class="show-users-header">
    <div class="bmw-bulletin-title flex">
      Manage Users
    </div>
    <div class="add-user-box">
      <div class="add-user bmw-button-secondary pointer"
        [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432":"#1c69d4"}'
        (click)="exportToCSV()">
        Report
      </div>
      <div class="add-user bmw-button-secondary pointer"
        [style]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432":"#1c69d4"}'
        [routerLink]='["/manage-user", "add"]'>
        Add New User
      </div>
    </div>
  </div>

  <div class="show-users-header">
    <div class="flex">
      <div class="cms-modal-select-make-checkbox">
        <label class="container">BMW
          <input type="radio" name="bmwradio" (change)='getAllUsersByMakeName()' value="BMW" [(ngModel)]='makeName'>
          <span class="checkmark"></span>
        </label>
        <label class="container">MINI
          <input type="radio" name="miniradio" (change)='getAllUsersByMakeName()' value="MINI" [(ngModel)]='makeName'>
          <span class="checkmark"></span>
        </label>
        <label class="container">ROLLSROYCE
          <input type="radio" name="rollsroyceradio" (change)='getAllUsersByMakeName()' value="ROLLSROYCE"
            [(ngModel)]='makeName'>
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
    <form class="find-users flex input-group" name="findDocs" style="width: 100%">
      <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px"
        placeholder="Find User" name="techDoc" [(ngModel)]='filterQuery' (change)="getAllUsersByMakeName()" />
      <div class="input-group-btn">
        <button
          [ngClass]="{'mini-button-style' : (APP_SETTINGS.isMINI === 'true'),'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true'), 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}"
          class="btn btn-default" type="submit">
          <i class="glyphicon glyphicon-search"></i>
        </button>
      </div>
    </form>
  </div>
  <app-table 
  [content]="table"
  (pageChange)="pageNumChange($event)" 
  (rowClick)="editUser($event)">
  </app-table>
</div>